import {
  CUSTOM_LIST_BASE_FILTER,
  CUSTOM_LIST_BASE_NUMERIC_FILTERS,
  CUSTOM_LIST_HITS_PER_PAGE,
  CUSTOM_LIST_INDEX_NAME,
} from './constants';

const escapeFilterValue = value => `"${String(value).replace(/"/g, '\\"')}"`;

const buildCustomListRequest = listId => ({
  indexName: CUSTOM_LIST_INDEX_NAME,
  params: {
    query: '',
    filters: `custom_list_ids:${escapeFilterValue(
      listId
    )} AND ${CUSTOM_LIST_BASE_FILTER}`,
    numericFilters: CUSTOM_LIST_BASE_NUMERIC_FILTERS,
    hitsPerPage: CUSTOM_LIST_HITS_PER_PAGE,
    attributesToRetrieve: ['product_id', 'custom_lists'],
    attributesToHighlight: [],
    analytics: false,
    clickAnalytics: true,
  },
});

export default buildCustomListRequest;
